import { createSlice } from '@reduxjs/toolkit';
import { participantName } from '../constants/liveStreamHelper';

export const roomParticipantSlice = createSlice({
  name: 'participantList',
  initialState: {
    roomParticipants: [],
    globalParticipants: [],
  },

  reducers: {
    updateNameToList: (state, action) => {
      const { identity, listType } = action.payload;
      const { name, userId } = participantName(identity);
      const tagHandle = identity.replace(' ', '').toLowerCase();
      // const seperatorIndex = identity.indexOf('_') + 1;
      // const name = identity?.substr(0, seperatorIndex - 1);
      const prevList = state[listType];

      return {
        ...state,
        [listType]: [
          ...prevList,
          { name: name, identity: userId, tagHandle: tagHandle },
        ],
      };
    },

    removeNameFromList: (state, action) => {
      const { identity, listType } = action.payload;
      const { name, userId } = participantName(identity);
      const prevList = state[listType];

      const newList = prevList.filter((p) => {
        return p?.identity !== userId;
      });
      return {
        ...state,
        [listType]: newList,
      };
    },

    clearList: (state, action) => {
      return { ...state, roomParticipants: [] };
    },

    clearGlobalParticipantList: (state, action) => {
      return { ...state, globalParticipants: [] };
    },
  },
});

export const {
  updateNameToList,
  removeNameFromList,
  clearList,
  clearGlobalParticipantList,
} = roomParticipantSlice.actions;

export default roomParticipantSlice.reducer;
